import TableList from "@components/templates/tablelist";
import {
    HttpGetFinanceList,
} from '@/service/products/allproducts'
export default {
    mixins: [TableList],
    components: {
        HttpGetFinanceList
    },
    data () {
        return {
            // totals: 0,
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                    // GE_updatedAt: null,
                    // LE_updatedAt: null
                }
            },
            exportdata: {},
            Searchs: {
                show: true,
                labelWidth: 120,
            },
            Plugins: { show: true },

        };
    },

    methods: {
        ajaxRequest: HttpGetFinanceList,
        handleOperates () {
            this.operate = {
                show: true,
                title: '批量更新费率',
                width: 460,
                showFooter: false,
                data: { contextId: global.SYSID },
                action: process.env.VUE_APP_APIURL_BI + "/api/v1/financeRates/import",
                name: "file",
                component: "compUpload",
                download: () => {
                    this.handleWebfs(process.env.VUE_APP_APIURL_BI + '/api/v1/financeRates/excel', { contextId: global.SYSID }, 'download')
                },
            };
        },
        interceptRequest(params) {
            return this.handleParams(params);
        },
        handleParams(params) {
            let searchData = params.search;
            if(searchData.EQ_period == ''){
                searchData.EQ_period = null;
            }else if(searchData.EQ_period != null && searchData.EQ_period != 'undefined'){
                const period = searchData.EQ_period.split('-');
                searchData.EQ_period = period[0] + period[1]
            }else {
                var time = new Date();
                var month = time.getMonth() + 1;
                if(month < 10){
                    month = '0' + month;
                }
                searchData.EQ_period = time.getFullYear() + month;
            }
            return {
                ...params,
                search: {
                    ...searchData
                }
            }
        },
    },
    computed: {
        ToolsData () {
            return [
                {
                    name: "批量更新",
                    operate: "update",
                    theme: 'success'
                }
            ]
        },
        SearchsData () {
            let stylewidth = "width:210px;"
            return [
                {
                    label: "汇率期间",
                    tag: 'vDatepicker',
                    key: 'EQ_period',
                    show: true,
                    props: {
                        options: this.options,
                        format: 'yyyy-mm',
                        confirm: false,
                    },
                    style: stylewidth,
                },
            ]
        },
        columns () {
            return [
                {
                    title: '从-币种',
                    render:(h,{row})=>{
                        return <div>
                        <div>{row.transferCurrency}</div>
                        </div>
                    }
                },
                {
                    title: '到-币种',
                    render:(h,{row})=>{
                        return <div>
                        <div>{row.targetCurrency}</div>
                        </div>
                    }
                },
                {
                    title: '上期初汇率',
                    render:(h,{row})=>{
                        return <div>
                        <div>{row.lastRate}</div>
                        </div>
                    }
                },
                {
                    title: '上期末汇率',
                    render:(h,{row})=>{
                        return <div>
                        <div>{row.lastRate}</div>
                        </div>
                    }
                },
                {
                    title: '期初汇率',
                    render:(h,{row})=>{
                        return <div>
                        <div>{row.rate}</div>
                        </div>
                    }
                },
                {
                    title: '汇率的更新时间',
                    render:(h,{row})=>{
                        return <div>
                        <div>{row.updatedAt}</div>
                        </div>
                    }
                },
            ];
        },

    },

};
